var map = {
	"./Rectangle.png": 1337,
	"./blog1.webp": 1893,
	"./blog2.webp": 2968,
	"./blog3.webp": 8315,
	"./blog4.webp": 918,
	"./blog5.webp": 9793,
	"./blog6.webp": 1684,
	"./blog7.webp": 6391,
	"./image.png": 1693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5398;